import { getContentType } from 'components/common/UploadModal/utils/getContentType';
import { MEDIA_TYPE } from 'constants/MediaConstants';
import type { AbstractMedia } from 'modules/medias/types/abstract-media';

/**
 * @param {AbstractMedia} media
 * @return {boolean}
 */
export const isSupportedMediaType = (media: AbstractMedia): boolean => {
  const contentType = getContentType(media, null); // When video is coming from the mobile app we don't retrieve any data that allow us to compute the content-type. Thus this value can be null.
  const is360 = media.type === MEDIA_TYPE.IMAGE_INSIDE_360 || media.type === MEDIA_TYPE[360];
  const isImage = !is360 && (media.type === MEDIA_TYPE.IMAGE || contentType?.match?.(/^image\/.*$/));

  const canPlay = !contentType || document.createElement('video').canPlayType(contentType) !== '';
  const isPlayableVideo = !is360 && (media.type === MEDIA_TYPE.VIDEO || contentType?.match?.(/^video\/.*$/)) && canPlay;

  const isPDF = contentType === 'application/pdf';
  return Boolean(isImage || isPlayableVideo || isPDF || is360);
};
